// extracted by mini-css-extract-plugin
module.exports = {"page":"_normal--page--1E5_w"};